import React from 'react';
import { Link } from 'react-router';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import FaqList from 'common/components/faqs';
import Support from 'marketing/containers/support';

const FAQ_QUESTIONS = [{
  question: "What is the crowdspring affiliate program and how does it work?",
  answer: "<p>If your audience could benefit from custom naming and design, crowdspring will pay $55 per client you refer.</p><p>The signup link below takes 20 seconds to apply and approval is immediate. You will receive a unique referral URL. Use this URL to send traffic to crowdspring.</p><p>When that traffic you refer pays for a project you will receive $55 deposited to your PayPal account (the industry's highest payout). We pay affiliates monthly and there is no minimum payout amount.</p><p>Crowdspring tracks the traffic you send to us with a 365 day tracking cookie (the best in the industry!) to give you credit for the sale of any traffic you refer.</p><p>After signup you will be able to see your affiliate dashboard and see who clicks on your link and if they purchased on crowdspring.</p>"
}, {
  question: "Are there any fees?",
  answer: "<p>We do not charge any fees!</p>"
}, {
  question: "Can I become an affiliate if I live outside the United States?",
  answer: "<p>Yes. Crowdspring helps clients around the world. We provide referral payments through PayPal.</p>"
}, {
  question: "If I have multiple websites, do I need to apply separately for each?",
  answer: "<p>No. You will receive one trackable URL and you can use that on any website.</p>"
}, {
  question: "Will you provide extra support for high-traffic websites?",
  answer: "<p>If you have a lot of traffic and want to discuss a specific partnership we are happy to learn how we can support you. Just email us at: affiliates@crowdspring.com</p>"
}];

const Affiliates = () => (
  <div>
    <Meta
      title="Affiliates"
      meta={[
        { name: 'robots', content: 'index,follow' },
        { name: 'description', content: 'crowdspring affiliate program' },
        { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' },
        { property: 'og:title', content: 'crowdspring affiliates' },
        { property: 'og:description', content: 'crowdspring affiliate program' },
        { property: 'og:url', content: getCanonicalURL('/affiliates/') },
      ]}
      link={[{ rel: 'canonical', href: getCanonicalURL('/affiliates/') }]}
    />
    <section className="block block-hero">
      <div className="row">
        <div className="small-16 medium-8 columns">
          <h1 className="hero-title">Become an affiliate.</h1>
          <h3 className="hero-subtitle">
            We offer the best terms in the industry, including a 365-day tracking cookie!
            Earn $55 for each converting client. It's quick & easy to get started.
          </h3>
          <div className="hero-actions">
            <a className="btn btn-tertiary btn-lg" target="_blank"
              href="https://crowdspring.ositracker.com/Index">
              Sign up now
            </a>
          </div>
        </div>
        <div className="small-16 medium-8 columns hide-for-small-only">
          <div className="artwork-container">
            <img
              src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_marketing_cta2-2x.png"
              className="artwork"
              alt="abu_hilmi's Artwork" />
          </div>
        </div>
      </div>
    </section>
    <section className="block block-affiliates-how">
      <div className="row columns">
        <div className="block-header">
          <h2>How the crowdspring affiliate program works.</h2>
        </div>
      </div>
      <div className="row medium-up-3 small-up-1">
        <div className="columns">
          <h2 className="step-name"><span className="step-number">1.</span>Sign up</h2>
          <ul>
            <li>
              <i className="fa fa-long-arrow-right" /> Fill out our short online application
            </li>
            <li>
              <i className="fa fa-long-arrow-right" /> Only takes a few minutes
            </li>
            <li>
              <i className="fa fa-long-arrow-right" /> Quick approvals
            </li>
          </ul>
        </div>
        <div className="columns">
          <h2 className="step-name"><span className="step-number">2.</span>Show ads</h2>
          <ul>
            <li>
              <i className="fa fa-long-arrow-right" /> Get custom affiliate links
            </li>
            <li>
              <i className="fa fa-long-arrow-right" /> Download custom affiliate banners
            </li>
            <li>
              <i className="fa fa-long-arrow-right" /> You decide how to promote
            </li>
          </ul>
        </div>
        <div className="columns">
          <h2 className="step-name"><span className="step-number">3.</span>Get paid</h2>
          <ul>
            <li>
              <i className="fa fa-long-arrow-right" /> No fees
            </li>
            <li>
              <i className="fa fa-long-arrow-right" /> Earn $55 for each converting client
            </li>
            <li>
              <i className="fa fa-long-arrow-right" /> 365-day tracking cookie
            </li>
          </ul>
        </div>
      </div>
      <div className="row align-center faq-row">
        <div className="columns medium-10 small-16">
          <h3 className="text-center">Frequently asked questions about our affiliate program.</h3>
          <FaqList data={FAQ_QUESTIONS} />
          <div className="text-center">
            <a className="btn btn-tertiary" target="_blank"
                href="https://crowdspring.ositracker.com/Index">
              Sign up now
            </a>
          </div>
        </div>
      </div>
    </section>

    <Support />
  </div>
);

export default Affiliates;



// WEBPACK FOOTER //
// ./marketing/about/affiliates.jsx